import React from 'react';
import { FormattedMessage } from 'react-intl';
import { defaults } from 'lodash';
import log from '../../log';
import { DeviceType } from '../../device';


import unselectDeviceIconURL from './unselectDevice/unselectDevice.png';

import arduinoUnoIconURL from './arduinoUno/arduinoUno.png';
import arduinoUnoConnectionIconURLL from './arduinoUno/arduinoUno-illustration.svg';
import arduinoUnoConnectionSmallIconURL from './arduinoUno/arduinoUno-small.svg';

import arduinoNanoIconURL from './arduinoNano/arduinoNano.png';
import arduinoNanoConnectionIconURLL from './arduinoNano/arduinoNano-illustration.svg';
import arduinoNanoConnectionSmallIconURL from './arduinoNano/arduinoNano-small.svg';

import arduinoLeonardoIconURL from './arduinoLeonardo/arduinoLeonardo.png';
import arduinoLeonardoConnectionIconURLL from './arduinoLeonardo/arduinoLeonardo-illustration.svg';
import arduinoLeonardoConnectionSmallIconURL from './arduinoLeonardo/arduinoLeonardo-small.svg';

import arduinoMega2560IconURL from './arduinoMega2560/arduinoMega2560.png';
import arduinoMega2560ConnectionIconURLL from './arduinoMega2560/arduinoMega2560-illustration.svg';
import arduinoMega2560ConnectionSmallIconURL from './arduinoMega2560/arduinoMega2560-small.svg';

import microbitIconURL from './microbit/microbit.png';
import microbitConnectionIconURLL from './microbit/microbit-illustration.svg';
import microbitConnectionSmallIconURL from './microbit/microbit-small.svg';

import microbitV2IconURL from './microbitV2/microbitV2.png';
import microbitV2ConnectionIconURLL from './microbitV2/microbitV2-illustration.svg';
import microbitV2ConnectionSmallIconURL from './microbitV2/microbitV2-small.svg';

import esp32IconURL from './esp32/esp32.png';
import esp32ConnectionIconURLL from './esp32/esp32-illustration.svg';
import esp32ConnectionSmallIconURL from './esp32/esp32-small.svg';

import esp8266NodeMCUIconURL from './esp8266NodeMCU/esp8266NodeMCU.png';
import esp8266NodeMCUConnectionIconURL from './esp8266NodeMCU/esp8266NodeMCU-illustration.svg';
import esp8266NodeMCUConnectionSmallIconURL from './esp8266NodeMCU/esp8266NodeMCU-small.svg';

import k210MaixDockIconURL from './k210MaixDock/k210MaixDock.png';
import k210MaixDockConnectionIconURLL from './k210MaixDock/k210MaixDock-illustration.svg';
import k210MaixDockConnectionSmallIconURL from './k210MaixDock/k210MaixDock-small.svg';

import k210MaixduinoIconURL from './k210Maixduino/k210Maixduino.png';
import k210MaixduinoConnectionIconURLL from './k210Maixduino/k210Maixduino-illustration.svg';
import k210MaixduinoConnectionSmallIconURL from './k210Maixduino/k210Maixduino-small.svg';

import raspberryPiPicoIconURL from './raspberryPiPico/raspberryPiPico.png';
import raspberryPiPicoConnectionIconURL from './raspberryPiPico/raspberryPiPico-illustration.svg';
import raspberryPiPicoConnectionSmallIconURL from './raspberryPiPico/raspberryPiPico-small.svg';

import makeymakeyIconURL from './makeymakey/makeymakey.png';
import makeymakeyConnectionIconURL from './makeymakey/makeymakey-illustration.svg';
import makeymakeyConnectionSmallIconURL from './makeymakey/makeymakey-small.svg';


/* add sensor device */
// 闪光灯
import yiFlashIconURL from './yiFlash/yiFlash.png';
import yiFlashConnectionIconURL from './yiFlash/yiFlash-illustration.svg';
import yiFlashConnectionSmallIconURL from './yiFlash/yiFlash-small.svg';

// 小夜灯
import yiNightLampIconURL from './yiNightLamp/yiNightLamp.png';
import yiNightLampConnectionIconURL from './yiNightLamp/yiNightLamp-illustration.svg';
import yiNightLampConnectionSmallIconURL from './yiNightLamp/yiNightLamp-small.svg';

// 红外线人体感应
import yiIrmotionIconURL from './yiIrmotion/yiIrmotion.png';
import yiIrmotionConnectionIconURL from './yiIrmotion/yiIrmotion-illustration.svg';
import yiIrmotionConnectionSmallIconURL from './yiIrmotion/yiIrmotion-small.svg';

// 光照传感器
import yiLightIconURL from './yiLight/yiLight.png';
import yiLightConnectionIconURL from './yiLight/yiLight-illustration.svg';
import yiLightConnectionSmallIconURL from './yiLight/yiLight-small.svg';

// 温湿度传感器
import yiThermeterIconURL from './yiThermeter/yiThermeter.png';
import yiThermeterConnectionIconURL from './yiThermeter/yiThermeter-illustration.svg';
import yiThermeterConnectionSmallIconURL from './yiThermeter/yiThermeter-small.svg';

// 温度传感器
import yiThermeterAIconURL from './yiThermeterA/yiThermeterA.png';
import yiThermeterAConnectionIconURL from './yiThermeterA/yiThermeterA-illustration.svg';
import yiThermeterAConnectionSmallIconURL from './yiThermeterA/yiThermeterA-small.svg';

// 音频传感器
import yiAudioIconURL from './yiAudio/yiAudio.png';
import yiAudioConnectionIconURL from './yiAudio/yiAudio-illustration.svg';
import yiAudioConnectionSmallIconURL from './yiAudio/yiAudio-small.svg';

// 六轴加速度计
import yiImu06IconURL from './yiImu06/yiImu06.png';
import yiImu06ConnectionIconURL from './yiImu06/yiImu06-illustration.svg';
import yiImu06ConnectionSmallIconURL from './yiImu06/yiImu06-small.svg';

// 九轴加速度计
import yiImu06xIconURL from './yiImu06x/yiImu06x.png';
import yiImu06xConnectionIconURL from './yiImu06x/yiImu06x-illustration.svg';
import yiImu06xConnectionSmallIconURL from './yiImu06x/yiImu06x-small.svg';

// 插座
import yiPlugIconURL from './yiPlug/yiPlug.png';
import yiPlugConnectionIconURL from './yiPlug/yiPlug-illustration.svg';
import yiPlugConnectionSmallIconURL from './yiPlug/yiPlug-small.svg';

// USB开关传感器
import ymSwusbIconURL from './ymSwusb/ymSwusb.png';
import ymSwusbConnectionIconURL from './ymSwusb/ymSwusb-illustration.svg';
import ymSwusbConnectionSmallIconURL from './ymSwusb/ymSwusb-small.svg';

// 三键传感器
import ymK3IconURL from './ymK3/ymK3.png';
import ymK3ConnectionIconURL from './ymK3/ymK3-illustration.svg';
import ymK3ConnectionSmallIconURL from './ymK3/ymK3-small.svg';
// 三色灯传感器
import ymRYGIconURL from './ymRYG/ymRYG.png';
import ymRYGConnectionIconURL from './ymRYG/ymRYG-illustration.svg';
import ymRYGConnectionSmallIconURL from './ymRYG/ymRYG-small.svg';
// 蜂鸣器传感器
import ymBeepIconURL from './ymBeep/ymBeep.png';
import ymBeepConnectionIconURL from './ymBeep/ymBeep-illustration.svg';
import ymBeepConnectionSmallIconURL from './ymBeep/ymBeep-small.svg';
// 5G
import ym5GIconURL from './ym5G/ym5G.png';
import ym5GConnectionIconURL from './ym5G/ym5G-illustration.svg';
import ym5GConnectionSmallIconURL from './ym5G/ym5G-small.svg';
// US超声测距 
import ymUSIconURL from './ymUS/ymUS.png';
import ymUSConnectionIconURL from './ymUS/ymUS-illustration.svg';
import ymUSConnectionSmallIconURL from './ymUS/ymUS-small.svg';
// 北斗GPS 
import ymBDGPSIconURL from './ymBDGPS/ymBDGPS.png';
import ymBDGPSConnectionIconURL from './ymBDGPS/ymBDGPS-illustration.svg';
import ymBDGPSConnectionSmallIconURL from './ymBDGPS/ymBDGPS-small.svg';
// 小智 
import ycAISIconURL from './ycAIS/ycAIS.png';
import ycAISConnectionIconURL from './ycAIS/ycAIS-illustration.svg';
import ycAISConnectionSmallIconURL from './ycAIS/ycAIS-small.svg';
const deviceData = [
    /**
     * Unselect the deivce back to pure scratch mode
     */
    {
        name: (
            <FormattedMessage
                defaultMessage="Unselect device"
                description="Name for the unselect device"
                id="gui.device.unselectDevice.name"
            />
        ),
        deviceId: 'null',
        iconURL: unselectDeviceIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Unselect the device, return to pure realtime programming mode."
                description="Description for the unselect device"
                id="gui.device.unselectDevice.description"
            />
        ),
        featured: true,
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['realtime']
    },
    // add sensor device
    {
        name: 'YM-LED',
        name_cn:'无线LED灯',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiFlash',
        color: "#76C75E",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiFlashIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A sensor that controls the lights."
                description="Description for the flash device"
                id="gui.device.yiFlash.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiIrmotionConnectionIconURL,
        connectionSmallIconURL: yiIrmotionConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiFlash.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-NLGT',
        name_cn:'小夜灯',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiNightLamp',
        color: "#4CAF50",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiNightLampIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A night light module."
                description="A night light module"
                id="gui.device.yiNightLamp.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiNightLampConnectionIconURL,
        connectionSmallIconURL: yiNightLampConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiNightLamp.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-PIR',
        name_cn:'无线红外人体传感器',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiIrmotion',
        color: "#E91E63",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiIrmotionIconURL,
        description: (
            <FormattedMessage
                defaultMessage="An infrared body sensor"
                description="Description for the irmotion device"
                id="gui.device.yiIrmotion.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiFlashConnectionIconURL,
        connectionSmallIconURL: yiFlashConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiIrmotion.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-DLGT',
        name_cn:'环境光传感器',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiLight',
        color: "#536DFE",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiLightIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A sensor that measures the intensity of light"
                description="Description for the irmotion device"
                id="gui.device.yiLight.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiLightConnectionIconURL,
        connectionSmallIconURL: yiLightConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiLight.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-TH1D',
        name_cn:'温湿度传感器',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiThermeter',
        color: "#76C75E",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiThermeterIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A sensor to measure temperature and humidity"
                description="Description for the irmotion device"
                id="gui.device.yiThermeter.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiThermeterConnectionIconURL,
        connectionSmallIconURL: yiThermeterConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiLight.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-TH1',
        name_cn:'温度传感器',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiThermeterA',
        color: "#4CAF50",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiThermeterAIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A sensor to measure temperature"
                description="Description for the irmotion device"
                id="gui.device.yiThermeterA.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiThermeterAConnectionIconURL,
        connectionSmallIconURL: yiThermeterAConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiThermeterA.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-AU',
        name_cn:'音频模块',
        deviceId: 'yiAudio',
        color: "#E91E63",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiAudioIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A voice synthesis broadcast module"
                description="A voice synthesis broadcast module"
                id="gui.device.yiAudio.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiAudioConnectionIconURL,
        connectionSmallIconURL: yiAudioConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiAudio.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-IMU6',
        name_cn:'六轴运动传感器',
        deviceId: 'yiImu06',
        color: "#536DFE",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiImu06IconURL,
        description: (
            <FormattedMessage
                defaultMessage="A six-axis accelerometer module"
                description="A six-axis accelerometer module"
                id="gui.device.yiImu06.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiImu06ConnectionIconURL,
        connectionSmallIconURL: yiImu06ConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiImu06.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-IMU9',
        name_cn:'9轴加速度计',
        deviceId: 'yiImu06x',
        color: "#76C75E",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiImu06xIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A nine-axis accelerometer module"
                description="A nine-axis accelerometer module"
                id="gui.device.yiImu06x.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiImu06xConnectionIconURL,
        connectionSmallIconURL: yiImu06xConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiImu06x.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YI PLUG',
        name_cn:'智能插座',
        // deviceId: 'LM-FLASH-51EC72',
        deviceId: 'yiPlug',
        color: "#4CAF50",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: yiPlugIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A controlled smart plugin"
                description="Description for the irmotion device"
                id="gui.device.yiPlug.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: yiPlugConnectionIconURL,
        connectionSmallIconURL: yiPlugConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.yiPlug.connectingMessage"
            />
        ),
        // programMode: ['upload'],
        // programLanguage: ['block', 'javascript'],
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-SWUSB',
        name_cn:'USB电源',
        deviceId: 'YMSWUSB',
        color: "#FF9800",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ymSwusbIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A USB switch sensor module"
                description="Description for the YM-SWUSB device"
                id="gui.device.YMSWUSB.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ymSwusbConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ymSwusbConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YMSWUSB.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-K3',
        name_cn:'3按键模块',
        deviceId: 'YMK3',
        color: "#2196F3",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ymK3IconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A 3-key button sensor module"
                description="Description for the YM-K3 device"
                id="gui.device.YMK3.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ymK3ConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ymK3ConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YMK3.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-RYG',
        name_cn:'3色LED灯',
        deviceId: 'YMRYG',
        color: "#FFD600",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ymRYGIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A three-color (red, yellow, green) lamp sensor module"
                description="Description for the YM-RYG device"
                id="gui.device.YMRYG.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ymRYGConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ymRYGConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YMRYG.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-BEEP',
        name_cn:'蜂鸣器',
        deviceId: 'YMBEEP',
        color: "#FF5722",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ymBeepIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A buzzer sensor module"
                description="Description for the YM-BEEP device"
                id="gui.device.YMBEEP.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ymBeepConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ymBeepConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YMBEEP.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-5G',
        name_cn:'5G模块',
        deviceId: 'YM5G',
        color: "#556600",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ym5GIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A buzzer sensor module"
                description="Description for the YM-5G device"
                id="gui.device.YM5G.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ym5GConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ym5GConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YM5G.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-US',
        name_cn:'超声测距',
        deviceId: 'YMUS',
        color: "#00CCFF",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ymUSIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A buzzer sensor module"
                description="Description for the YM-BEEP device"
                id="gui.device.YMUS.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ymUSConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ymUSConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YMUS.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YM-GNSS',
        name_cn:'定位',
        deviceId: 'YMGNSS',
        color: "#002244",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ymBDGPSIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A buzzer sensor module"
                description="Description for the YM-BEEP device"
                id="gui.device.YMGNSS.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ymBDGPSConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ymBDGPSConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YMBDGPS.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    {
        name: 'YC-AIS',
        name_cn:'小智',
        deviceId: 'YCAIS',
        color: "#FF7566",
        manufactor: 'iot4u.cn',
        learnMore: 'http://iot4u.cn/',
        type: DeviceType.sensor,
        iconURL: ycAISIconURL, // 请替换为实际的图片路径
        description: (
            <FormattedMessage
                defaultMessage="A buzzer sensor module"
                description="Description for the YM-BEEP device"
                id="gui.device.YCAIS.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        serialportRequired: false,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: false,
        useAutoScan: true,
        connectionIconURL: ycAISConnectionIconURL, // 请替换为实际的连接图标路径
        connectionSmallIconURL: ycAISConnectionSmallIconURL, // 请替换为实际的小图标路径
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.YCAIS.connectingMessage"
            />
        ),
        programMode: ['realtime'],
        programLanguage: ['block'],
        tags: ['sensor'],
        helpLink: 'https://iot4u.cn/',
    },
    // Arduino
    {
        name: 'Arduino Uno',
        deviceId: 'arduinoUno',
        manufactor: 'arduino.cc',
        learnMore: 'https://store.arduino.cc/usa/arduino-uno-rev3',
        type: DeviceType.arduino,
        iconURL: arduinoUnoIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A great board to get started with electronics and coding."
                description="Description for the Arduino Uno device"
                id="gui.device.arduinoUno.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '9600',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: arduinoUnoConnectionIconURLL,
        connectionSmallIconURL: arduinoUnoConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.arduinoUno.connectingMessage"
            />
        ),
        programMode: ['realtime', 'upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://store.arduino.cc/usa/arduino-uno-rev3'
    },
    {
        name: 'Arduino Nano',
        deviceId: 'arduinoNano',
        manufactor: 'arduino.cc',
        learnMore: 'https://store.arduino.cc/usa/arduino-nano',
        type: DeviceType.arduino,
        iconURL: arduinoNanoIconURL,
        description: (
            <FormattedMessage
                defaultMessage="The Arduino Nano is a classic small board to build your projects with."
                description="Description for the Arduino Nano device"
                id="gui.device.arduinoNano.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '9600',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: arduinoNanoConnectionIconURLL,
        connectionSmallIconURL: arduinoNanoConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.arduinoNano.connectingMessage"
            />
        ),
        programMode: ['realtime', 'upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://store.arduino.cc/usa/arduino-nano'
    },
    {
        name: 'Arduino Leonardo',
        deviceId: 'arduinoLeonardo',
        manufactor: 'arduino.cc',
        learnMore: 'https://store.arduino.cc/usa/leonardo',
        type: DeviceType.arduino,
        iconURL: arduinoLeonardoIconURL,
        description: (
            <FormattedMessage
                defaultMessage="The classic Arduino board that can act as a mouse or keyboard."
                description="Description for the Arduino Leonardo device"
                id="gui.device.arduinoLeonardo.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '9600',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: arduinoLeonardoConnectionIconURLL,
        connectionSmallIconURL: arduinoLeonardoConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.arduinoLeonardo.connectingMessage"
            />
        ),
        programMode: ['upload'], // due to the software serilport realtim mode is unstable
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://store.arduino.cc/usa/leonardo'
    },
    {
        name: 'Arduino Mega 2560',
        deviceId: 'arduinoMega2560',
        manufactor: 'arduino.cc',
        learnMore: 'https://store.arduino.cc/usa/mega-2560-r3',
        type: DeviceType.arduino,
        iconURL: arduinoMega2560IconURL,
        description: (
            <FormattedMessage
                defaultMessage="The 8-bit board with 54 digital pins, 16 analog inputs, and 4 serial ports."
                description="Description for the Arduino Mega 2560 device"
                id="gui.device.arduinoMega2560.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '9600',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: arduinoMega2560ConnectionIconURLL,
        connectionSmallIconURL: arduinoMega2560ConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.arduinoMega2560.connectingMessage"
            />
        ),
        programMode: ['realtime', 'upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://store.arduino.cc/usa/mega-2560-r3'
    },
    {
        name: 'ESP32',
        deviceId: 'arduinoEsp32',
        manufactor: 'espressif',
        learnMore: 'https://www.espressif.com/',
        type: DeviceType.arduino,
        iconURL: esp32IconURL,
        description: (
            <FormattedMessage
                defaultMessage="Wi-Fi & Bluetooth control board with rich functions."
                description="Description for the esp32 device"
                id="gui.device.esp32.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '115200',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: esp32ConnectionIconURLL,
        connectionSmallIconURL: esp32ConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their esp32."
                id="gui.device.esp32.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://docs.espressif.com/projects/esp-idf/zh_CN/latest/esp32/hw-reference/esp32/get-started-devkitc.html'
    },
    {
        name: 'NodeMCU',
        deviceId: 'arduinoEsp8266NodeMCU',
        manufactor: 'espressif',
        learnMore: 'https://www.nodemcu.com',
        type: DeviceType.arduino,
        iconURL: esp8266NodeMCUIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Low-cost Wi-Fi SOC control board."
                description="Description for the esp8266 NodeMCU device"
                id="gui.device.esp8266NodeMCU.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '76800',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: esp8266NodeMCUConnectionIconURL,
        connectionSmallIconURL: esp8266NodeMCUConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.esp8266NodeMCU.connectingMessage"
            />
        ),
        deviceExtensionsCompatible: 'arduinoEsp8266',
        programMode: ['upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://arduino-esp8266.readthedocs.io/en/3.0.0/index.html'
    },
    {
        name: 'MaixDock',
        deviceId: 'arduinoK210MaixDock',
        manufactor: 'sipeed',
        learnMore: 'https://wiki.sipeed.com/',
        type: DeviceType.arduino,
        iconURL: k210MaixDockIconURL,
        description: (
            <FormattedMessage
                defaultMessage="A control board based on the K210 RISC-V chip that only has basic functions and leads out all IO pins." // eslint-disable-line max-len
                description="Description for the K210 MaixDock device"
                id="gui.device.k210MaixDock.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '115200',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: k210MaixDockConnectionIconURLL,
        connectionSmallIconURL: k210MaixDockConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.k210MaixDock.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://wiki.sipeed.com/hardware/zh/maix/maixpy_develop_kit_board/Maix_dock.html'
    },
    {
        name: 'Maixduino',
        deviceId: 'arduinoK210Maixduino',
        manufactor: 'sipeed',
        learnMore: 'https://maixduino.sipeed.com/',
        type: DeviceType.arduino,
        iconURL: k210MaixduinoIconURL,
        description: (
            <FormattedMessage
                defaultMessage="The K210 RISC-V board with ESP32 inside."
                description="Description for the K210 maixduino device"
                id="gui.device.k210Maixduino.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '115200',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: k210MaixduinoConnectionIconURLL,
        connectionSmallIconURL: k210MaixduinoConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.k210Maixduino.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://wiki.sipeed.com/soft/maixpy/en/develop_kit_board/maix_duino.html'
    },
    {
        name: 'Raspberry Pi Pico',
        deviceId: 'arduinoRaspberryPiPico',
        manufactor: 'Raspberry Pi Foundation',
        learnMore: 'https://www.raspberrypi.com/',
        type: DeviceType.arduino,
        iconURL: raspberryPiPicoIconURL,
        description: (
            <FormattedMessage
                defaultMessage="The powerful, flexible microcontroller board."
                description="Description for the Raspberry Pi Pico device"
                id="gui.device.raspberryPiPicoIconURL.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '9600',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: raspberryPiPicoConnectionIconURL,
        connectionSmallIconURL: raspberryPiPicoConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.raspberryPiPicoIconURL.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
    },
    {
        name: 'Micro:bit',
        deviceId: 'microbit',
        manufactor: 'microbit.org',
        learnMore: 'https://microbit.org/',
        type: DeviceType.microbit,
        iconURL: microbitIconURL,
        description: (
            <FormattedMessage
                defaultMessage="The pocket-sized computer transforming digital skills learning."
                description="Description for the micro:bit device"
                id="gui.device.microbit.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '115200',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: microbitConnectionIconURLL,
        connectionSmallIconURL: microbitConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.microbit.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'microPython'],
        tags: ['microPython'],
        helpLink: 'https://microbit.org/get-started/first-steps/introduction/'
    },
    {
        name: 'Micro:bit V2',
        deviceId: 'microbitV2',
        manufactor: 'microbit.org',
        learnMore: 'https://microbit.org/',
        type: DeviceType.microbit,
        iconURL: microbitV2IconURL,
        description: (
            <FormattedMessage
                defaultMessage="Upgraded processor, built-In speaker and microphone, touch sensitive logo."
                description="Description for the micro:bit V2 device"
                id="gui.device.microbitV2.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '115200',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: microbitV2ConnectionIconURLL,
        connectionSmallIconURL: microbitV2ConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.microbitV2.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'microPython'],
        tags: ['microPython'],
        helpLink: 'https://microbit.org/get-started/first-steps/introduction/'
    },
    {
        name: 'Makey Makey',
        deviceId: 'makeyMakey',
        manufactor: 'makeymakey.com',
        learnMore: 'https://makeymakey.com/',
        type: DeviceType.arduino,
        iconURL: makeymakeyIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Make anything into a key."
                description="Description for the Makey Makey device"
                id="gui.device.makeymakey.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        serialportRequired: true,
        defaultBaudRate: '115200',
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: makeymakeyConnectionIconURL,
        connectionSmallIconURL: makeymakeyConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their device."
                id="gui.device.makeyMakey.connectingMessage"
            />
        ),
        programMode: ['upload'],
        programLanguage: ['block', 'c', 'cpp'],
        tags: ['arduino'],
        helpLink: 'https://makeymakey.com'
    },
    /**
     * For those parent devices that exist in VM but are not displayed in GUI
     */
    {
        deviceId: 'arduinoUnoUltra',
        type: DeviceType.arduino,
        featured: true,
        disabled: false,
        hide: true
    },
    {
        deviceId: 'arduinoSE',
        type: DeviceType.arduino,
        featured: true,
        disabled: false,
        hide: true
    },
    {
        deviceId: 'arduinoEsp8266',
        type: DeviceType.arduino,
        featured: true,
        disabled: false,
        hide: true
    },

];

/**
 * Unique event blocks under different programming frameworks.
 */
const eventBlock = {
    [DeviceType.arduino]: '<block type="event_whenarduinobegin"/>',
    [DeviceType.microPython]: '<block type="event_whenmicropythonbegin"/>',
    [DeviceType.microbit]: `<block type="event_whenmicrobitbegin"/>
                                <block type="event_whenmicrobitbuttonpressed"/>
                                <block type="event_whenmicrobitpinbeingtouched"/>
                                <block type="event_whenmicrobitgesture"/>`
};

/**
 * To get real device id. eg: the third party id like ironKit_arduinoUno.
 * @param {string} deviceId - the id of the device.
 * @return {string} deviceId - the real device id.
 */
const analysisRealDeviceId = deviceId => {
    // if the id contain '_' use the string afer the '_'.
    if (deviceId.indexOf('_') !== -1) {
        return deviceId.split('_')[1];
    }
    return deviceId;
};

/**
 * Make device data from the input data. If it is a buid-in device, return the buid-in
 * data. If it is a third party device, find it's parent device, and overwrite its attributes
 * with the input data.
 * @param {string} deviceList - the list of devices.
 * @return {string} fullData - processed data of devices.
 */
const makeDeviceLibrary = (deviceList = null) => {
    let regeneratedDeviceData = [];

    if (deviceList) {
        if (deviceList[0].isOrdered) { // External resources customize the device arrangement
            regeneratedDeviceData.push(deviceData[0]);
        } else {
            deviceList = deviceData.concat(deviceList);
        }

        deviceList.forEach(dev => {
            const realDeviceId = analysisRealDeviceId(dev.deviceId);
            const matchedDevice = deviceData.find(item => realDeviceId === item.deviceId);
            if (matchedDevice) {
                if (realDeviceId !== dev.deviceId) {
                    return regeneratedDeviceData.push(defaults({}, dev, { hide: false }, matchedDevice));
                }
                return regeneratedDeviceData.push(matchedDevice);
            }
            log.warn('Unable to find the corresponding built-in device:', dev.deviceId);
            return;
        });
    } else {
        regeneratedDeviceData = deviceData;
    }

    return regeneratedDeviceData;
};

export {
    deviceData as default,
    eventBlock,
    makeDeviceLibrary
};
